namespace Matrix.Rebalancer {
    export class ModellingViewColumnSetColumns {
        static columnsKey = 'Rebalancer.ModellingViewColumnSet';
    }
}
